//import * as React from 'react';
import CardActions from '@material-ui/core/CardActions';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBack from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import Print from '@material-ui/icons/Print';
import React, { useEffect, useRef, useState } from 'react';
import { Button, CreateButton, EditButton, Loading, SimpleShowLayout, Title, useShowController } from 'react-admin';
import { Link } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import AlertDialogConfirmation from '../dialog/AlertDialogConfirmation';
import AlertDialogOuiNoAnnule from '../dialog/AlertDialogOuiNoAnnule';
import ChatFullScreenDialog from '../dialog/ChatFullScreenDialog';
import DialogShare from '../dialog/DialogShare.js';
import FormDialogPayement from '../dialog/FormDialogPayement';
import { createAutorisation, has_role,getBaseUrlCheckAdmin } from '../references';
import InvoiceDetails from './InvoiceDetails';
import EtiqPlusieurs from '../printEtiquette/EtiqPlusieurs';
import Assignment from '@material-ui/icons/Assignment';
import ButtonEtiquette from '@material-ui/core/Button';


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    flexDirection: 'column'
};


const InvoiceShow = (props, ...rest) => {

    const [open, setOpen] = useState(false);
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const useStyles = makeStyles({
        root: { width: window.width < 840 ? window.width : '840px', margin: 'auto' },
        spacer: { height: 10 },
        invoices: { margin:  "0", padding: "0" },
        color_client: { color: '#7209b7', fontWeight: 'bold', padding: 0, margin: 0 }
    });

    const classes = useStyles();
    const componentRef = useRef();
    const [titre, setTitre] = useState();
    const [roles, setRole] = useState();
    const [showEtiquette, setShowEtiquette] = useState(false);
    const {permissions}=props;

    //const [record, setRecord] = useState();
    //const record = useRecordContext();

    const { record,resource } = useShowController(props);

    //const record = useRecordContext();
    //console.log(record)
    //console.log(props);
    useEffect(() => {
        setTitre('Facture_'+getPdfName(record));
        setRole(localStorage.getItem('roles'));
        //console.log(btoa('adiallo258888/6566'));
    }, []);


    const getPdfName = (record) => {
        var infos='';
        if(record && record.order){
            infos=record.order.client_exp.fullname + "_" + record.order.code;
        }else if(record && record.client_exp){
            infos=record.client_exp + "_" + record.code;
        }else{
            return '';
        }
        return infos;
    }

    const handleClickOpenFromShow = (forOpen) => {
        setOpen(forOpen);
      };
      const handleDelete = (id) => {
          setOpenDeleteConfirm(true);
      };
    const infosFacture = (data, separateur) => {

        return "Cher Client(e)," + separateur +
            "Veuillez trouver des éléments de votre facture ci-dessous." + separateur +
            "N'hésitez pas à nous contacter si vous avez des questions." + separateur +
            "Au plaisir de vous envoyer vos prochains colis !!" + separateur + separateur +

            "Agent : " + data.orderDetails.fullname + separateur +
            "N° facture : " + data.order.code + separateur +
            "Date facture : " + data.orderDetails.createdDate + separateur +
            "Arrivée pévue : " + data.order.campagne.dateArrive + separateur +
            "Montant payé : " + data.orderLineStat.total_encaisse + " €" + separateur +
            "Reste à payer : " + data.orderLineStat.reste_a_payer + " €" + separateur + separateur +

            "TLDI Logistique Services" + separateur + "54 Rue DE CLIGNANCOURT 75018 PARIS" + separateur +
            "Tel agence Guinée : +224628130578/+224625468698" + separateur +
            "Tel agence France : +33699000649/+33973648929" + separateur +
            "Email : contact@tldilogistique.com" + separateur +
            "Siret : 888 332 244 R.C.S PARIS" + separateur +
            "IBAN : FR51 3000 2004 3900 0037 5767 Z61" + separateur +
            "BIC : CRLYFRPP"
    }

    const handleShowEtiquette=(isShowEtiquette)=>{
        const infos=getPdfName(record);
        var varTitre= isShowEtiquette?'Etiquette_'+infos:'Facture_'+infos;
        setShowEtiquette(isShowEtiquette);
        setTitre(varTitre);
    }
    const PostShowActions = ({ resource,basePath }) => (
        <CardActions style={cardActionStyle}>
            <Button color="primary" onClick={handlePrint} label="Imprimer"><Print /></Button>
            <Button component={Link} to={basePath} label="Retour" color="primary" ><ArrowBack/></Button>

            {createAutorisation(roles,resource) ? <CreateButton basePath={basePath} />:null}

            {(record && record.order &&  record.order.status==='ATTENTE') && 
                (has_role(roles,'ROLE_MANAGER') || createAutorisation(roles,resource))? 
                <EditButton basePath={getBaseUrlCheckAdmin(permissions,record.id,'edit','fret',record.order.campType)} record={record} label="EDITER" /> : null
            }

            {createAutorisation(roles,resource) ?  <Button label="Encore" onClick={() => handleClickOpenFromShow(true)}><PlusOneIcon/></Button>:null}


            <ButtonEtiquette startIcon={<Assignment />}  color="primary" onClick={()=>handleShowEtiquette(true)}>Etiquette</ButtonEtiquette>
            <DialogShare titre="Partage" message="Choisissez l'application de partage ?"
                shareUrl={infosFacture(record, "\n")
                }
                to={record.order.client_exp.email}
            />

            <ChatFullScreenDialog idDetFact={record.id} titreChat={record.order.code + ' : ' + record.order.client_exp.fullname} />
            {record.orderLineStat.reste_a_payer ? <FormDialogPayement data={{id:record.id,
                                                                            reste_a_payer:record.orderLineStat.reste_a_payer,
                                                                            total_general:record.orderLineStat.total_general}} /> : null}
       
            {
                has_role(roles,'ROLE_MANAGER') && record.order.status==='ATTENTE' ?
                <Button color="primary" onClick={()=>handleDelete(record.id)}  style={{color:'red'}}  label="Annuler"><DeleteIcon/></Button>
                : null
            }
        </CardActions>
    );

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: titre
    });

    const handleDeleteConfirm=()=>{
        setOpenDeleteConfirm(false);
    }


    
    const ShowEtiquetteActions = ({ resource,basePath }) => (
        <CardActions style={cardActionStyle}>
            <ButtonEtiquette color="primary" onClick={handlePrint}><Print />Imprimer</ButtonEtiquette>
            <ButtonEtiquette  label="Retour" color="primary"  onClick={()=>handleShowEtiquette(false)} ><ArrowBack />Retour</ButtonEtiquette>
        </CardActions>
    );

  

    return (
        (!record || !record.order)  ? <Loading /> :
        showEtiquette ?
        <>
            <Title title={'Etiquette - '+record.order.code} />
            <span  >
            <ShowEtiquetteActions {...props}></ShowEtiquetteActions>
            <SimpleShowLayout className={classes.root} >
                <div ref={componentRef} className={classes.invoices}  >
                    <EtiqPlusieurs   {...props} record={record} />
                </div>
                </SimpleShowLayout> 
            </span>
        </>
        :
        <>
            <Title title={'Facture - '+record.order.code} />
            <AlertDialogConfirmation idDetFact={record.id} affiche={openDeleteConfirm} redirectOui={props.basePath} 
                titre="Confirmation d'annulation" message="Etes vous sûre de vouloir annuler cette facture ?"
                handleDeleteConfirm={handleDeleteConfirm}
                resource={resource}
                />
            <AlertDialogOuiNoAnnule withCancelButton={true} handleClickOpenFromShow={handleClickOpenFromShow} openFromShow={open} data={record}  redirectOui={props.basePath} />
            
            <span  >
               <PostShowActions {...props}></PostShowActions>
              
               <SimpleShowLayout className={classes.root}  >
                   <div className={classes.invoices} ref={componentRef}  ><InvoiceDetails facture={record} /></div>
               </SimpleShowLayout>
           </span>
        </>
    );
};

export default InvoiceShow;

